import { QuestionExplanation } from '../../types'

export const SPELLINGREGEL_EXPLANATIONS: Record<string, QuestionExplanation> = {
  'SPL-L1-001': {
    id: 'SPL-L1-001',
    explanation:
      'Korte klinker (a), dus je krijgt een dubbele medeklinker (nn).',
    distractorExplanations: {
      '1': 'Dan zou je "paa-nen" zeggen (lange klank). De a is kort, dus dubbel n.',
      '2': 'Dit is geen bestaand meervoud.',
      '3': 'Foutief achtervoegsel.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Korte Klinker Regel',
        content:
          'Korte klinker (pan, kat, pit) → dubbele medeklinker in meervoud (pannen, katten, pitten)',
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'SPL-L1-002': {
    id: 'SPL-L1-002',
    explanation: 'Woorden op -lijk klinken als "luk", maar je schrijft lijk.',
    distractorExplanations: {
      '1': 'Je schrijft wat je hoort (fonetisch), maar de regel is -lijk.',
      '2': 'Foutieve uitgang.',
      '3': 'Je hebt een e te veel toegevoegd.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: '-lijk Regel',
        content:
          'Woorden op -lijk klinken als "luk", maar je schrijft altijd -lijk (gevaarlijk, heerlijk)',
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'SPL-L2-001': {
    id: 'SPL-L2-001',
    explanation:
      'Als na de C een a, o, of u komt, klinkt hij als een K (Cola, Cactus).',
    distractorExplanations: {
      '1': 'Hier klinkt de C als een S.',
      '2': 'Hier klinkt de C als een S.',
      '3': 'Hier klinkt de C als een S.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'C-Regel',
        content:
          'C + a/o/u = K-klank (cactus, cola). C + e/i = S-klank (cent, cijfer)',
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'SPL-L2-002': {
    id: 'SPL-L2-002',
    explanation:
      'Namen van steden, landen en personen schrijf je altijd met een hoofdletter.',
    distractorExplanations: {
      '1': 'Gewone voorwerpen krijgen geen hoofdletter.',
      '2': 'Dagen van de week krijgen in het Nederlands géén hoofdletter!',
      '3': 'Seizoenen krijgen geen hoofdletter.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Hoofdletter Regel',
        content:
          'Hoofdletters voor: begin zin, namen (personen, steden, landen), en het woord "ik"',
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'SPL-L3-001': {
    id: 'SPL-L3-001',
    explanation:
      'Maak de zin vragend: "Loopt de oude man...?" Het werkwoord dat vooraan komt, is de persoonsvorm.',
    distractorExplanations: {
      '1': 'Dat is een zelfstandig naamwoord.',
      '2': 'Dat is het onderwerp (wie loopt er?).',
      '3': 'Dat zegt iets over hoe hij loopt (bijwoord).',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Persoonsvorm Vinden',
        content:
          'Maak de zin vragend. Het werkwoord dat vooraan komt, is de persoonsvorm. "Loopt de man?" → loopt',
        icon: 'lightbulb',
      },
      showWhen: 'wrong',
    },
  },
  'SPL-L3-002': {
    id: 'SPL-L3-002',
    explanation:
      "Voltooid deelwoord van bezeren. Stam is bezeer. R zit niet in 't kofschip, dus eindigt het op een d.",
    distractorExplanations: {
      '1': 'Je hoort een t, maar je schrijft een d (maak het langer: bezeer-de).',
      '2': 'Dit is een mix van verleden tijd en voltooid deelwoord.',
      '3': 'Dt komt nooit voor aan het eind van een voltooid deelwoord.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Voltooid Deelwoord d/t',
        content:
          "Stam eindigt NIET op 't kofschip? Dan eindigt het voltooid deelwoord op -d. Bezeer → bezeerd",
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'SPL-L3-003': {
    id: 'SPL-L3-003',
    explanation:
      'Meervoud van idee is ideeën. Het trema zorgt dat je e-en apart uitspreekt.',
    distractorExplanations: {
      '1': 'Zonder trema lees je "ie-deen".',
      '2': 'Het trema staat op de verkeerde e.',
      '3': 'Je schrijft geen i ertussen.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Trema Regel',
        content:
          'Een trema (¨) laat zien dat twee klinkers apart uitgesproken worden: idee → ideeën (idee-en)',
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },

  // NIEUW: Weetwoorden met é (café-woord)
  'SPL-WEET-L1-001': {
    id: 'SPL-WEET-L1-001',
    explanation:
      'Café is een weetwoord met é (met accent). Je moet het uit je hoofd leren. Het komt uit het Frans.',
    distractorExplanations: {
      '1': 'Zonder accent is het fout. Café schrijf je met é.',
      '2': "Twee e's is te veel. Het is café, niet cafee.",
      '3': 'Dit accent (è) bestaat niet in café. Het moet é zijn.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Weetwoorden met é',
        content:
          'Sommige woorden schrijf je met é (accent aigu). Dit zijn weetwoorden uit het Frans: café, idée (oud Nederlands).',
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'SPL-WEET-L1-002': {
    id: 'SPL-WEET-L1-002',
    explanation:
      "Idee schrijf je zonder accent. Alleen café heeft een é. Idee is gewoon met twee e's.",
    distractorExplanations: {
      '1': 'Idee heeft geen accent. Alleen café heeft é.',
      '2': 'Dit is de oude spelling. Nu schrijven we gewoon idee.',
      '3': "Te weinig letters. Het is idee met twee e's.",
    },
  },
  'SPL-WEET-L1-003': {
    id: 'SPL-WEET-L1-003',
    explanation: 'Koffie schrijf je met ie aan het eind. Dit is een weetwoord.',
    distractorExplanations: {
      '1': 'Zonder e is het fout. Het is koffie, niet koffi.',
      '2': 'Koffie heeft geen accent. Alleen café heeft é.',
      '3': 'Met y is het fout. In het Nederlands schrijven we ie.',
    },
  },
  'SPL-WEET-L2-001': {
    id: 'SPL-WEET-L2-001',
    explanation:
      'Café is het enige woord in deze lijst met een é (accent aigu).',
    distractorExplanations: {
      '1': "Idee heeft geen accent, gewoon twee e's.",
      '2': 'Thee heeft geen accent, gewoon ee.',
      '3': 'Koffie heeft geen accent, gewoon ie.',
    },
  },
  'SPL-WEET-L2-002': {
    id: 'SPL-WEET-L2-002',
    explanation: 'Café schrijf je met é. Dit moet je uit je hoofd leren.',
    distractorExplanations: {
      '1': 'Zonder accent is het fout.',
      '2': "Twee e's is fout. Het is café, niet cafee.",
      '3': 'Dit accent (è) bestaat niet in café.',
    },
  },
  'SPL-WEET-L2-003': {
    id: 'SPL-WEET-L2-003',
    explanation:
      'Café heeft een é, idee heeft gewoon ee. Beide zijn goed gespeld.',
    distractorExplanations: {
      '1': 'Cafe zonder accent is fout. Het moet café zijn.',
      '2': 'Cafè met verkeerd accent is fout.',
      '3': 'Idee heeft geen accent. Alleen café heeft é.',
    },
  },

  // NIEUW: Weetwoorden met eau (cadeau-woord)
  'SPL-WEET-L1-004': {
    id: 'SPL-WEET-L1-004',
    explanation:
      'Cadeau is een weetwoord met eau. Je moet het uit je hoofd leren. Het komt uit het Frans.',
    distractorExplanations: {
      '1': 'Cado is spreektaal, maar niet correct Nederlands.',
      '2': 'Kadeau met k is fout. Het begint met c.',
      '3': 'Kado is spreektaal, maar niet correct Nederlands.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Weetwoorden met eau',
        content:
          'Sommige woorden schrijf je met eau. Dit zijn weetwoorden uit het Frans: cadeau, bureau, niveau.',
        icon: 'book',
      },
      showWhen: 'wrong',
    },
  },
  'SPL-WEET-L1-005': {
    id: 'SPL-WEET-L1-005',
    explanation:
      'Bureau is een weetwoord met eau. Je moet het uit je hoofd leren.',
    distractorExplanations: {
      '1': 'Buro is spreektaal, maar niet correct Nederlands.',
      '2': 'Bureu is fout. Het is bureau met eau.',
      '3': 'Buroo is fout. Het is bureau met eau.',
    },
  },
  'SPL-WEET-L2-004': {
    id: 'SPL-WEET-L2-004',
    explanation: 'Cadeau schrijf je met eau. Dit is de correcte spelling.',
    distractorExplanations: {
      '1': 'Cado is spreektaal, maar op school schrijf je cadeau.',
      '2': 'Kadeau met k is fout. Het begint met c.',
      '3': 'Kado is spreektaal, maar niet correct.',
    },
  },
  'SPL-WEET-L2-005': {
    id: 'SPL-WEET-L2-005',
    explanation: 'Bureau eindigt op -eau. Dit is een weetwoord uit het Frans.',
    distractorExplanations: {
      '1': 'Auto eindigt op o, niet op eau.',
      '2': 'Menu eindigt op u, niet op eau.',
      '3': 'Euro eindigt op o, niet op eau.',
    },
  },
  'SPL-WEET-L3-001': {
    id: 'SPL-WEET-L3-001',
    explanation: 'Cadeau en bureau zijn beide correct gespeld met eau.',
    distractorExplanations: {
      '1': 'Cado en buro zijn spreektaal, niet correct Nederlands.',
      '2': 'Kadeau met k is fout. Het moet cadeau zijn met c.',
      '3': 'Buro is spreektaal. Het moet bureau zijn.',
    },
  },
  'SPL-WEET-L3-002': {
    id: 'SPL-WEET-L3-002',
    explanation: 'Bureau en cadeau zijn beide weetwoorden met eau.',
    distractorExplanations: {
      '1': 'Buro en cado zijn spreektaal, niet correct.',
      '2': 'Bureau is goed, maar cado is spreektaal.',
      '3': 'Buro is spreektaal, maar cadeau is goed.',
    },
  },
  'SPL-WEET-L3-003': {
    id: 'SPL-WEET-L3-003',
    explanation:
      'Idee heeft geen eau, maar gewoon ee. De andere drie hebben wel eau: café (heeft é, niet eau), cadeau en bureau.',
    distractorExplanations: {
      '1': 'Café heeft é, niet eau. Maar het hoort wel bij de weetwoorden.',
      '2': 'Cadeau heeft wel eau!',
      '3': 'Bureau heeft wel eau!',
    },
  },
}
